import { NotificationPriorities } from "@elit-hair/elitklinik-shared";
import { useTranslation } from "react-i18next";
import { TbUrgent } from "react-icons/tb";

import { CommonLabel } from "@/components/CommonInput";
import CommonSelector, { CommonSelectorItem } from "@/components/CommonSelector";
import { notificationPriorities } from "@/constants/notificationPriorities";

import { CreateNotificationFormType } from "./CreateNotificationForm";

const options = Object.values(NotificationPriorities).filter((priority) => typeof priority === "string");
function CreateNotificationPrioritySelector() {
    const { t } = useTranslation();

    return (
        <CommonLabel className="col-span-4" label={t("notificationPriority")}>
            <CommonSelector<CreateNotificationFormType, NotificationPriorities>
                icon={TbUrgent}
                name="priority"
                options={options}
                getOptionLabel={(val) => {
                    return t("notification_priorities." + (val || ""));
                }}
                placeholder="notificationPriority"
                renderOption={({ option }) => {
                    return (
                        <CommonSelectorItem<NotificationPriorities>
                            option={option}
                            options={notificationPriorities}
                            prefix="notification_priorities."
                        />
                    );
                }}
            />
        </CommonLabel>
    );
}

export default CreateNotificationPrioritySelector;
